class CollectionHeader extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false

    this.updateStickyOffset()
    this.checkStickyState()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.checkStickyState = this.checkStickyState.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.updateStickyOffset = this.updateStickyOffset.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.updateStickyOffset, { passive: true })
  }

  updateStickyOffset () {
    const siteHeader =
      document.getElementById('shopify-section-header') ||
      document.querySelector('[data-section-type="header"]')

    if (!siteHeader) return

    const { height } = siteHeader.getBoundingClientRect()

    this.style.setProperty('--CollectionGrid_StickyOffset', `${height}px`)
  }

  onScroll () {
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.checkStickyState)

    this.isTicking = true
  }

  checkStickyState () {
    this.isTicking = false

    this.updateStickyOffset()

    const thisTop = this.getBoundingClientRect().top
    const parentTop = this.parentNode.getBoundingClientRect().top

    this.classList.toggle(
      'clc-ProductGrid_Header-sticky',
      thisTop !== parentTop,
    )

    document.body.classList.toggle(
      'lyt-Theme-hasStickyBar',
      thisTop !== parentTop,
    )
  }
}

if (!customElements.get('collection-header')) {
  customElements.define('collection-header', CollectionHeader)
}
